// document.querySelectorAll('.js-toggle').forEach(toggle => {
//   toggle.addEventListener('click', e => {
//     e.preventDefault();

//     const icons = toggle.querySelectorAll('.js-toggle-change');
//     icons.forEach(icon => icon.classList.toggle('tw-hidden'));
//   });
// });

// Marcar link activo y abrir submenú si aplica
const currentUrl = window.location.href;

document.querySelectorAll('.js-navigation__link').forEach(link => {
  const li = link.closest('.navigation__item');
  if (!li) return;

  // Marcar link activo
  if (link.href === currentUrl) {
    link.classList.add('active');

    // Recorrer todos los li padres que tengan submenú y abrirlos
    let parentLi = li.closest('.navigation__item--with-children') || li.parentElement.closest('.navigation__item--with-children');
    while (parentLi) {
      parentLi.classList.add('navigation__item--open');

      // Ajustar height
      const childTier = parentLi.querySelector('.navigation__child-tier');
      if (childTier) {
        childTier.style.height = `${childTier.firstElementChild.clientHeight}px`;
      }

      // Ajustar iconos del toggle
      const toggleBtn = parentLi.querySelector('.js-toggle');
      const icons = toggleBtn ? toggleBtn.querySelectorAll('.js-toggle-change') : [];
      if (icons.length === 2) {
        icons[0].classList.add('tw-hidden');  // ocultar primer icono
        icons[1].classList.remove('tw-hidden'); // mostrar segundo icono
      }

      // Subir al siguiente padre
      parentLi = parentLi.parentElement.closest('.navigation__item--with-children');
    }
  }
});

// Función para recalcular height de los submenús abiertos
function updateOpenHeights() {
  document.querySelectorAll('.navigation__item.navigation__item--open').forEach(item => {
    const childTier = item.querySelector('.navigation__child-tier');
    if (childTier) {
      childTier.style.height = `${childTier.firstElementChild.clientHeight}px`;
    }
  });
}

// Recalcular al redimensionar ventana
window.addEventListener('resize', updateOpenHeights);

// LLamarlo una vez al cargar, por si ya hay submenús abiertos por URL
updateOpenHeights();